<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                {{'Validation errors'|translate}}
            </span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar style="font-size: 36px; color: red; font-weight: bold;">
        <span *ngIf="reason==='names'">{{'Customer with provided first name and second name already exists!'|translate}}</span>
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">
        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close()"
                aria-label="Confirm">
            {{'Confirm'|translate}}
        </button>
    </div>
</div>
